import styled from 'styled-components';
import { motion } from 'framer-motion';

// Contenedor principal de página
export const PageContainer = styled.div`
    min-height: 100vh;
    background: linear-gradient(135deg, #e1e4d5 0%, #c3cfe2 100%);
    padding-top: 80px;
    
    @media screen and (max-width: 768px) {
        padding-top: 120px;
    }
    
    @media screen and (max-width: 480px) {
        padding-top: 100px;
    }
`;

// Sección principal
export const PageSection = styled.section`
    padding: 4rem 0;
    min-height: calc(100vh - 80px);
    
    @media screen and (max-width: 768px) {
        padding: 2rem 0;
        min-height: calc(100vh - 120px);
    }
    
    @media screen and (max-width: 480px) {
        min-height: calc(100vh - 100px);
    }
`;

// Contenedor para vista completa sin scroll
export const FullViewContainer = styled.div`
    min-height: 100vh;
    // Deja lugar para la navbar (60px) para que no tape el título
    padding-top: 80px;
    background: linear-gradient(135deg, #e1e4d5 0%, #c3cfe2 100%);
    overflow: visible;

    @media screen and (max-width: 768px) {
        padding-top: 120px;
        height: auto;
        min-height: 100vh;
        overflow: visible;
    }
    
    @media screen and (max-width: 480px) {
        padding-top: 100px;
        height: auto;
        min-height: 100vh;
        overflow: visible;
    }
`;

// Sección para vista completa
export const FullViewSection = styled.section`
    min-height: calc(100vh - 80px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 0;

    @media screen and (max-width: 768px) {
        height: auto;
        min-height: calc(100vh - 120px);
        padding: 2rem 0;
    }
    
    @media screen and (max-width: 480px) {
        height: auto;
        min-height: calc(100vh - 100px);
        padding: 1.5rem 0;
    }
`;

// Contenedor de contenido
export const PageContent = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
    
    @media screen and (max-width: 768px) {
        padding: 0 1rem;
    }
`;

// Contenedor de contenido para vista completa
export const FullViewContent = styled.div`
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    @media screen and (max-width: 768px) {
        padding: 0 1rem;
    }
`;

// Título principal de página
export const PageTitle = styled(motion.h1)`
    font-size: 3.5rem;
    font-weight: 700;
    color: #066a67;
    text-align: center;
    margin-bottom: 3rem;
    background: linear-gradient(135deg, #066a67 0%, #18776a 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    
    @media screen and (max-width: 768px) {
        font-size: 2.5rem;
        margin-bottom: 2rem;
    }
`;

// Título compacto para vista completa
export const CompactTitle = styled(motion.h1)`
    font-size: 3rem;
    font-weight: 700;
    color: #066a67;
    text-align: center;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, #066a67 0%, #18776a 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    
    @media screen and (max-width: 768px) {
        font-size: 2rem;
        margin-bottom: 0.5rem;
    }
`;

// Subtítulo
export const PageSubtitle = styled(motion.h2)`
    font-size: 1.5rem;
    font-weight: 400;
    color: #7f8c8d;
    text-align: center;
    margin-bottom: 3rem;
    line-height: 1.6;
    
    @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-bottom: 2rem;
    }
`;

// Subtítulo compacto para vista completa
export const CompactSubtitle = styled(motion.h2)`
    font-size: 1.4rem;
    font-weight: 400;
    color: #7f8c8d;
    text-align: center;
    margin-bottom: 2rem;
    line-height: 1.4;

    @media screen and (max-width: 768px) {
        font-size: 1.15rem;
        margin-bottom: 1.25rem;
    }
`;

// Contenedor de texto
export const TextContainer = styled(motion.div)`
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 3rem;
    margin-bottom: 3rem;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    
    @media screen and (max-width: 768px) {
        padding: 2rem;
        margin-bottom: 2rem;
        border-radius: 15px;
    }
`;

// Contenedor de texto compacto para vista completa
export const CompactTextContainer = styled(motion.div)`
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 18px;
    padding: 2.25rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);

    @media screen and (max-width: 768px) {
        padding: 1.5rem;
        margin-bottom: 1rem;
        border-radius: 12px;
    }
`;

// Texto principal
export const PageText = styled.p`
    font-size: 1.1rem;
    line-height: 1.8;
    color: #066a67;
    text-align: justify;
    text-justify: inter-word;
    margin-bottom: 1.5rem;
    
    &:last-child {
        margin-bottom: 0;
    }
    
    @media screen and (max-width: 768px) {
        font-size: 1rem;
        line-height: 1.6;
    }
`;

// Texto compacto para vista completa
export const CompactText = styled.p`
    font-size: 1.1rem;
    line-height: 1.7;
    color: #066a67;
    text-align: justify;
    text-justify: inter-word;
    margin-bottom: 1.1rem;

    &:last-child {
        margin-bottom: 0;
    }

    @media screen and (max-width: 768px) {
        font-size: 1rem;
        line-height: 1.6;
    }
`;

// Subtítulo y lista de pasos dentro de un bloque de texto de servicio
export const ServiceListTitle = styled.h3`
    font-size: 1.2rem;
    font-weight: 700;
    color: #066a67;
    margin: 1.5rem 0 0.75rem;

    @media screen and (max-width: 768px) {
        font-size: 1.1rem;
    }
`;

export const ServiceList = styled.ul`
    margin: 0;
    padding-left: 1.25rem;
    list-style: disc;

    li {
        font-size: 1.1rem;
        line-height: 1.7;
        color: #066a67;
        margin-bottom: 0.6rem;
    }

    li:last-child {
        margin-bottom: 0;
    }

    li::marker {
        color: #18776a;
    }

    @media screen and (max-width: 768px) {
        li {
            font-size: 1rem;
            line-height: 1.6;
        }
    }
`;

// Contenedor de video mejorado
export const VideoContainer = styled(motion.div)`
    position: relative;
    width: 100%;
    max-width: 800px;
    margin: 3rem auto;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
    background: #000;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(45deg, rgba(52, 152, 219, 0.1), rgba(155, 89, 182, 0.1));
        z-index: 1;
        pointer-events: none;
    }
    
    @media screen and (max-width: 768px) {
        margin: 2rem auto;
        border-radius: 15px;
    }
`;

// Contenedor de video compacto para vista completa
export const CompactVideoContainer = styled(motion.div)`
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 1.5rem auto;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
    background: #000;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(45deg, rgba(52, 152, 219, 0.1), rgba(155, 89, 182, 0.1));
        z-index: 1;
        pointer-events: none;
    }
    
    @media screen and (max-width: 768px) {
        margin: 1rem auto;
        border-radius: 10px;
        max-width: 90%;
    }
`;

// Video player mejorado
export const VideoPlayer = styled.video`
    width: 100%;
    height: auto;
    display: block;
    border-radius: 20px;
    
    @media screen and (max-width: 768px) {
        border-radius: 15px;
    }
`;

// Contenedor de imagen mejorado
export const ImageContainer = styled(motion.div)`
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 3rem auto;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(45deg, rgba(52, 152, 219, 0.1), rgba(155, 89, 182, 0.1));
        z-index: 1;
        pointer-events: none;
    }
    
    @media screen and (max-width: 768px) {
        margin: 2rem auto;
        border-radius: 15px;
    }
`;

// Contenedor de imagen compacto para vista completa
export const CompactImageContainer = styled(motion.div)`
    position: relative;
    width: 100%;
    max-width: 400px;
    margin: 1.5rem auto;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(45deg, rgba(52, 152, 219, 0.1), rgba(155, 89, 182, 0.1));
        z-index: 1;
        pointer-events: none;
    }
    
    @media screen and (max-width: 768px) {
        margin: 1rem auto;
        border-radius: 10px;
        max-width: 80%;
    }
`;

// Imagen mejorada
export const PageImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
    border-radius: 20px;
    transition: transform 0.3s ease;
    
    &:hover {
        transform: scale(1.02);
    }
    
    @media screen and (max-width: 768px) {
        border-radius: 15px;
    }
`;

// Grid para contenido
export const ContentGrid = styled(motion.div)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    align-items: center;
    margin: 3rem 0;
    
    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 2rem;
        margin: 2rem 0;
    }
`;

// Grid compacto para vista completa
export const CompactContentGrid = styled(motion.div)`
    display: grid;
    // minmax(0, 1fr) evita que el contenido ensanche las columnas más allá de la pantalla
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 2rem;
    align-items: center;
    height: 100%;
    
    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 2rem;
        height: auto;
        min-height: auto;
    }
    
    @media screen and (max-width: 480px) {
        gap: 1.5rem;
    }
`;

// Columna de texto
export const TextColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    
    @media screen and (max-width: 768px) {
        height: auto;
        min-height: auto;
    }
`;

// Columna de media
export const MediaColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    // En desktop el carrusel (y el botón debajo) quedan arriba, a la altura del texto,
    // en lugar de centrados respecto de un texto largo
    align-self: start;
    position: sticky;
    top: 90px;
    
    @media screen and (max-width: 768px) {
        height: auto;
        min-height: auto;
        position: static;
    }
`;

// Contenedor del carousel
export const CarouselContainer = styled(motion.div)`
    position: relative;
    width: 100%;
    max-width: 580px;
    height: 400px;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
    background: #000;

    @media screen and (max-width: 768px) {
        max-width: 100%;
        height: 280px;
        margin: 1rem 0;
    }
    
    @media screen and (max-width: 480px) {
        height: 250px;
        margin: 0.5rem 0;
    }
`;

// Slide del carousel
export const CarouselSlide = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// Imagen del carousel
export const CarouselImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

// Video del carousel
export const CarouselVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

// Controles del carousel
export const CarouselControls = styled.div`
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 10;
`;

// Botón del carousel
export const CarouselButton = styled.button`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: none;
    background: ${props => props.active ? '#18776a' : 'rgba(255, 255, 255, 0.5)'};
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        background: #18776a;
        transform: scale(1.2);
    }
`;

// Flechas del carousel
export const CarouselArrow = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: white;
    font-size: 1.5rem;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;
    
    &:hover {
        background: rgba(0, 0, 0, 0.8);
        transform: translateY(-50%) scale(1.1);
    }
    
    &.prev {
        left: 10px;
    }
    
    &.next {
        right: 10px;
    }
    
    @media screen and (max-width: 768px) {
        width: 35px;
        height: 35px;
        font-size: 1.2rem;
    }
`;

// Card de contenido
export const ContentCard = styled(motion.div)`
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 2.5rem;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
    }
    
    @media screen and (max-width: 768px) {
        padding: 2rem;
        border-radius: 15px;
    }
`;

// Título de sección
export const SectionTitle = styled(motion.h3)`
    font-size: 2rem;
    font-weight: 600;
    color: #066a67;
    margin-bottom: 1.5rem;
    text-align: center;
    
    @media screen and (max-width: 768px) {
        font-size: 1.5rem;
        margin-bottom: 1rem;
    }
`;

// Botón CTA de servicios (WhatsApp). A diferencia del Button global,
// permite que el texto largo baje de línea, así se ve bien en mobile.
export const ServiceCtaButton = styled.a`
    display: inline-block;
    text-align: center;
    text-decoration: none;
    white-space: normal;
    line-height: 1.3;
    max-width: 420px;
    border-radius: 8px;
    background: none;
    padding: 14px 28px;
    font-size: 1rem;
    font-weight: 600;
    color: #066a67;
    border: 2px solid #066a67;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: #066a67;
        color: #fff;
    }

    &:active {
        transform: scale(0.98);
    }

    @media screen and (max-width: 480px) {
        display: block;
        width: 100%;
        max-width: 320px;
        margin: 0 auto;
        padding: 14px 18px;
        font-size: 0.95rem;
    }
`;

// Animaciones
export const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3
        }
    }
};

export const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6 }
    }
};

export const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { duration: 0.8 }
    }
};

export const slideUpVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6 }
    }
};
